<template>
  <div class="home">
    <Nav />
    <div
      class="scroll-container-vertical"
      :style="{
        height: scrollVerticalHeight,
      }"
    >
      <div class="scroll-container-horizontal">
        <div
          class="scroll-container"
          :style="{ transform: `translate3d(${-scrollHeight}px,0px,0px)` }"
        >
          <main ref="scrollContainerHorizontal">
            <Part1 />
            <Part2 />
            <Part3 />
            <Part4 />
            <Part5 />
          </main>
        </div>
      </div>
    </div>
    <div
      class="video_wrapper"
      id="geekpark_video_iframe_wrapper"
      style="display: none"
    >
      <div class="innner_yellow_border" />
      <div class="innner_black_bg" />
      <iframe
        id="geekpark_video_iframe"
        style="position: absolute; width: 100%; height: 100%; left: 0; top: 0"
        src=""
        frameborder="no"
        scrolling="no"
      ></iframe>
      <img
        alt="关闭视频"
        class="close_video_btn"
        src="https://summit-img.geekpark.net/r2020/close_video_btn.svg"
        @click="closeVideo"
      />
    </div>
  </div>
</template>

<script>
import Nav from "@/components/pc/Nav.vue";
import Part1 from "@/components/pc/Part1.vue";
import Part2 from "@/components/pc/Part2.vue";
import Part3 from "@/components/pc/Part3.vue";
import Part4 from "@/components/pc/Part4.vue";
import Part5 from "@/components/pc/Part5.vue";

export default {
  name: "HomePC",
  components: {
    Nav,
    Part1,
    Part2,
    Part3,
    Part4,
    Part5,
  },
  data() {
    return {
      scrollVerticalHeight: "4000px",
      scrollVerticalMarginLeft: "0px",
      scrollHeight: 0,
      timer: null,
      navVisible: true,
      moveOnImgPosition1: 0,
    };
  },
  created() {
    window.onload = () => this.setClientSize();
    window.addEventListener("scroll", this.handleScroll, false);
    window.addEventListener("resize", this.setClientSize, false);
  },
  mounted() {
    this.timer = setTimeout(() => {
      const images = document.querySelectorAll("img");
      for (let i = 0; i < images.length; i++) {
        if (!images[i].complete) {
          return;
        }
      }
      this.setClientSize();
    }, 100);
    window.history.scrollRestoration &&
      (window.history.scrollRestoration = "manual");
    const links = document.querySelectorAll(".navs-container > .nav_item_link");
    for (let i = 0, { length } = links; i < length; i++) {
      links[i].addEventListener("click", function (e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        if (href && href.startsWith("#")) {
          window.scrollTo({
            behavior: "smooth",
            top:
              document.querySelector(href).offsetLeft -
              document.querySelector("#nav").offsetWidth,
          });
        } else {
          window.open(href, "_blank");
        }
        return false;
      });
    }
  },
  methods: {
    init() {
      setTimeout(this.setClientSize);
    },
    setClientSize(flag) {
      const CLIENT_WIDTH = document.body.clientWidth;
      const CLIENT_HEIGHT = document.body.clientHeight;
      this.computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT);
    },
    computeScrollVerticalHeight(CLIENT_WIDTH, CLIENT_HEIGHT) {
      this.scrollVerticalHeight = `${
        this.$refs.scrollContainerHorizontal.offsetWidth -
        CLIENT_WIDTH +
        CLIENT_HEIGHT
      }px`;
    },
    // 滚动处理函数
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      // if (this.scrollHeight <= 0) {
      //   this.scrollVerticalMarginLeft = `${
      //     document.querySelector("#nav").offsetWidth
      //   }px`;
      //   return;
      // }
      if (scrollInstance < 0) {
        this.scrollVerticalMarginLeft = `${
          document.querySelector("#nav").offsetWidth
        }px`;
      } else {
        this.scrollVerticalMarginLeft = "0px";
      }
    },
    closeVideo() {
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      vIframeWrapper.style.display = "none";
      vIframe.src = "";
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.setClientSize);
    clearTimeout(this.timer);
  },
};
</script>

<style scoped lang="less">
.home {
  position: relative;
  height: 100vh;
}

.scroll-container-vertical {
  overflow-scrolling: touch;
}

.scroll-container-horizontal {
  position: fixed;
  left: 0;
  top: 0;
  // z-index: -3;
  background: #f3f3f3;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.scroll-container {
  height: 100vh;
  align-self: flex-end;
}

main {
  display: flex;
  position: relative;
}

.video_wrapper {
  position: fixed;
  padding: 20% 31%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  z-index: 99999;
  .close_video_btn {
    position: absolute;
    top: -16px;
    right: -16px;
    height: 36px;
    width: auto;
    z-index: 99;
    &:hover {
      cursor: pointer;
    }
  }
  .innner_black_bg {
    background: #000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
